<template>
  <div v-if="type == 'jobs'">
      <v-row>
        <v-col cols="3">
            <div class="jobs-search-bar">
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Refine"
                    single-line
                    hide-details
                ></v-text-field>
            </div>
        </v-col>

        <TableRefresh 
          class="pt-1"
          :state="loading"
          @click.native="refreshTable"
        />
        <v-spacer/>
        <v-col cols="1">
          <v-icon v-if="!excelLoading" @click="exportExcel">
            mdi-file
          </v-icon>
          <v-icon v-else class="updating">
            mdi-refresh
          </v-icon>
        </v-col>
      </v-row>

      <v-data-table
        :search="search"
        :headers="headers"
        :items="tableData"
        :expanded.sync="expanded"
        :loading="loading"
        sort-by="created_on"
        :sort-desc="true"
        class="elevation-1 admin-table click-row"
        :items-per-page="100"
        hide-default-footer
        @click:row="clickRow"
      >   
        <template v-slot:item.created_on="{ item }">
            {{ formateCreatedDate(item.created_on) }}
        </template>
        <template v-slot:item.due_on="{ item }">
            {{ formateDate(item.due_on) }}
        </template>
        <template v-slot:progress>
            <v-progress-linear color="blue" height="2" indeterminate></v-progress-linear>
        </template>
        <template v-slot:item.completion="{ item }">
            <v-progress-circular
                :rotate="-90"
                :value="convertString(item.done)"
                :color="returnJobState(item)"
            ></v-progress-circular>
        </template>

        <template v-slot:item.refresh="{ item }">
            <RefreshLoader 
                :id="item.id"
                :ref="item.id"
                :item="item"
                @loaderClicked="refreshJob"
            />
        </template>

        <template v-slot:item.action="{ item }">
            <v-menu bottom left>
                <template v-slot:activator="{ on }">
                    <v-btn dark icon v-on="on" @click.stop.prevent>
                        <v-icon color="black">mdi-dots-vertical</v-icon>
                    </v-btn>
                </template>

                <v-list>
                    <v-list-item
                        v-for="(opt, i) in filteredOptions"
                        :key="i"
                        :disabled="disableOpt(i, item)"
                        @click="clickOption(opt, item)"
                    >
                        <v-list-item-title>{{ opt }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
                <DetailedInfo
                    :key="item.id"
                    :job="selectedJob"
                    @toggleAssignmentComp="toggleAssignmentComp"
                />
            </td>
        </template>
    </v-data-table>
    <Pagination
      :pagination-info="paginationInfo"
      @updatedPage="fetchNewPage"
    />
    <DeviceAssignment
        v-if="showDeviceAssignment"
        :orgs="orgs"
        :selected-devices="selectedDevices"
        @closeDeviceAssignment="showDeviceAssignment = !showDeviceAssignment"
    />
  </div>
</template>

<script>

import { GetJobById } from "@/services/API.js"
import { search } from '@/mixins/quickSearch.js'

import { mapState, mapActions } from "vuex";

import RefreshLoader from '@/components/general/RefreshLoader.vue';
import DeviceAssignment from '@/views/DeviceManagement/components/DeviceAssignment.vue';
import TableRefresh from '@/components/general/TableRefresh.vue';
import DetailedInfo from '@/views/Jobs/Sections/DetailedInfo.vue';
import Pagination from './Pagination.vue';


import { AmplifyEventBus } from "aws-amplify-vue"

import * as xlsx from 'xlsx'

import moment from "moment"

import { Logger } from "aws-amplify"
const logger = new Logger("JobsNow")

export default {
  name: 'Jobs',
  components: {
    RefreshLoader,
    DeviceAssignment,
    TableRefresh,
    DetailedInfo,
    Pagination
  },
  mixins: [ search ],
  props: {
    latestjob: {
        type: Object,
        required: false,
        default: () => {}
    },
    type: {
      required: true,
      type: String
    }
  },
  data() {
    return {
      search: '',
      mode: "new",
      modal: false,
      transfer: false,
      tasks: false,
      options: ["Open", "Archive", "Cancel"],
      headers: [
          { text: "Job", value: "name" },
          { text: "Type", value: "type", sortable: true },
          { text: "Created On", value: "created_on" },
          { text: "Due Date", value: "due_on" },
          { text: "Created By", value: "created_by" },
          { text: "Assignee", value: "assigned_to" },
          { text: 'Assignee\'s Organisation', value: 'org' },
          { text: "Status", value: "completion" },
          { text: "Refresh", value: "refresh", sortable: false },
          { text: "Actions", value: "action", sortable: false }
      ],
      expanded: [],
      task: {},
      org: "",
      loading: false,
      jobUpdating: false,
      showDeviceAssignment: false,
      selectedDevices: [],
      installTags: [],
      selectedJob: {},
      paginationInfo: {
        pageNum: 1,
        pageCount: 1,
        pageSize: 100
      },
      page: 1,
      excelLoading: false
    }
  },
  computed: {
    ...mapState([
      'quickSearchResults',
      'quickSearchPayload',
      'orgs'
    ]),
    userCan () {
        return {
            Install: this.$can('createDeviceInstallJob'),
            'Firmware Update': this.$can('createFirmwareUpdateJob'),
            'Device Config': this.$can('createDeviceConfigJob'),
        }
    },
    currentSearchType() {
      return 'Jobs';
    },
    hasData() {
      const data = this.quickSearchResults;

      return Object.keys(data).length > 0;
    },
    tableData() {
      const data = this.quickSearchResults;
      let items = [];

      if(this.hasData) {
        items = data.res.Result;

        items.map(job => {
          let assigned = 0
            job.type = this.returnType(job)
            job.done = job.Tasks.reduce((sum, task, index) => {
                if (!task.hasOwnProperty('context')) return;
                const complete = task.context.devices ? task.context.devices.filter(tag => tag.install_tag != '').length : 0;
                const pending = task.context.pending_otc ? task.context.pending_otc.length : 0;
                const assignedVehi = task.context.devices ? task.context.devices.filter(tag => tag.vehicle_name).length : 0;
                task.done = complete / (pending + complete)
                task.assigned = assignedVehi / (pending + assignedVehi)
                task.num_devices = pending + complete
                assigned = assigned + task.assigned
                if (index === job.Tasks.length - 1)
                    return Math.floor(((sum + task.done) * 100) / job.Tasks.length)
                return sum + task.done
            }, 0)
            job.assigned = Math.floor((assigned * 100) / job.Tasks.length)
            job.completion = this.returnJobState(job, false)
            return job
        })
      }
      return items;
    },
    currentPage() {
      return this.hasData ? this.quickSearchPayload.pageNum : 1;
    },
    currentRoute() {
      return this.$route.path;
    },
    hasPayload() {
      const data = this.quickSearchPayload;

      return Object.keys(data).length > 0;
    },
    filteredOptions () {
        return this.options.filter(i => !this.hideOption[i])
    },
    // hide any menu options the user should not be able to use
    hideOption () {
        return {
            "Archive": !this.$can('archiveJob'),
            "Cancel": !this.$can('deleteJob')
        }
    }
  },
  watch: {
    latestjob(job) {
      this.jobs.push(job);
    },
    quickSearchResults: {
      handler() {
        this.buildPaginationInfo();
      },
      deep: true
    }
  },
  async mounted() {
    this.getOrgs();
    this.buildPaginationInfo();
    AmplifyEventBus.$on("job-now", this.handleJob)
  },
  destroyed() {
    AmplifyEventBus.$off("job-now")
  },
  methods: {
    async exportExcel() {
      this.excelLoading = true

      const exportSheetName = `Jobs-Global-Search-${moment().format('YYYY-MM-DDTHH:mm:ss')}`

      const headers = [
				'Job',
				'Type',
        'Created On',
        'Due Date',
        'Created By',
        'Assignee',
        'Assignee\'s Organisation',
        'Status'
      ]

      const payloadCopy = JSON.parse(JSON.stringify(this.quickSearchPayload))
      const fullSearch = await this.fullSearch(payloadCopy, this.paginationInfo)

      const data = [
        headers,
        [],
        ...fullSearch.map(item => [
          item.name,
          item.type,
          item.created_on,
          item.due_on,
          item.created_by,
          item.assigned_to,
          item.org,
          item.completion
        ])
      ]
      logger.info('export devices', data)
      // Create a new workbook
      const wb = xlsx.utils.book_new()

      const ws = xlsx.utils.aoa_to_sheet(data)

        const colWidths = data[0].map((_, colIndex) => {
          const maxLength = data.reduce((max, row) => {
            const cellValue = row && row[colIndex] ? row[colIndex].toString() : ''
            return Math.max(max, cellValue.length)
          }, 0)
          return { width: maxLength + 2 }; // Add a little extra padding
        })

        // Set column widths in the worksheet
        ws['!cols'] = colWidths

        // Append the worksheet to the workbook
        xlsx.utils.book_append_sheet(wb, ws, 'Jobs')

        // Write the workbook to a file (e.g., 'example.xlsx')
        xlsx.writeFile(wb, exportSheetName + ".xlsx")

        this.excelLoading = false
    },
    ...mapActions(["getOrgs"]),
    convertString(val) {
      if (!val) return '0';
      return val.toString();
    },
    async refreshTable() {
      if(!this.hasPayload) return;
      this.loading = true;

      const search = await this.quickSearch(this.quickSearchPayload, this.currentRoute);

      if (search) {
        this.loading = false;
      }
      else {
        this.loading = false;
      }
    },
    async fetchNewPage(page) {
      if(!this.hasData) return
      if(page == this.currentPage) return

      this.loading = true;

      this.$store.commit('updateQuickSearchPage', page);

      const search = await this.quickSearch(this.quickSearchPayload, this.currentRoute);

      if (search) {
        this.$store.commit('setQuickSearchPayload', this.quickSearchPayload);
        this.loading = false;
      }
      else {
        this.loading = false;
      }
      logger.info('handle page update ', page)
    },
    buildPaginationInfo() {
      if(!this.quickSearchResults.hasOwnProperty('res')) return;

      const data = this.quickSearchResults.res;
      logger.info('hello bud', data)
      if(data.hasOwnProperty('page_number')) {
        this.paginationInfo.pageNum = data.page_number;
      }
      if(data.hasOwnProperty('total_pages')) {
        this.paginationInfo.pageCount = data.total_pages;
      }
      logger.info('has pagination info ', this.paginationInfo)
    },
    returnType(job) {
      if (!job || !job.Tasks.length > 0) return ''
      const map = {
          device_config: 'Device Config',
          firmwareupdate: 'Firmware Update',
          taskinstall: 'Install'
      }
      const type = job.Tasks[0].task_type

      return map.hasOwnProperty(type) ? map[type] : ''
    },

    statusColourOptions(progress) {
      if (!progress) return 'grey';

      if (progress < 100) {
          return 'orange';
      }
      else {
          return 'green';
      }
    },
    returnJobState(job, returnColour = true) {
      logger.info(job)
      if(!job.Tasks.length > 0) return '';

      const type = job.Tasks[0].task_type;
      const count = job.done;

      if(type == 'configupdate' || type == 'firmwareupdate') {
          const items = job.Tasks[0].context.devices;
          const total = job.Tasks[0].context.devices.length;
          const pending = items.filter(item => {
          return item.status_name === "pending";
          });
          const state = (100 * (total - pending.length) / total);
          
          return returnColour ? this.statusColourOptions(state) : state;

      }
      else {
          if (isNaN(count)) return 0;

          return returnColour ? this.statusColourOptions(count) : count;
      }
    },
    checkJobType(item, type) {
      const tasks = item.Tasks;
      
      return tasks.length > 0 && tasks[0].task_type == type ? true : false;
    },
    configItems(list) {
      let itemList = list.tasks[0].context.devices;

      return itemList;
    },
    returnConfig(item) {
      let task = item.tasks[0];

      if (task.context) {
          return task.context.device_config.data;
      }
    },
    toggleAssignmentComp(device) {
      let tags = device.context.devices.map(tag => {
          return {
              'id' : tag.logical_id,
              'install_tag' : tag.install_tag
          }
      });

      this.selectedDevices = tags;
      this.showDeviceAssignment = !this.showDeviceAssignment;
    },
    parseInstallTags(data) {
      this.installTags = data.task.context.devices.filter((tag) => !tag.vehicle_name);
    },
    formateCreatedDate(date) {
      return moment(date).format("YYYY-MM-DD HH:mm:ss")
    },
    formateDate(date) {
      return moment(date).format("DD/MM/YYYY")
    },
    returnOrgID(orgName) {
      let id = this.orgs.find(org => org.name === orgName);

      return id.id;
    },
    async refreshJob(item) {
      // Prevent panel from opening/closing on job refresh
      this.clickRow(item);
      const payload = {
        filters: [
          {
            attribute: 'id',
            value: item.id
          }
        ]
      }
      
      let refreshedJob = await GetJobById(payload);

      if (refreshedJob.Jobs) {
          window.EventBus.$emit("jobRefreshComplete");

          let latest = refreshedJob.Jobs[0];

          for (const job in this.jobs) {
              if (this.jobs[job].id == latest.id) {
                  this.jobs[job].done = latest.done;
                  this.jobs[job].Tasks[0].context.pending_otc = latest.Tasks[0].context.pending_otc;
                  this.jobs[job].Tasks[0].context.devices = latest.Tasks[0].context.devices;
              }
          }
      } else {
          logger.info('there was an error');
      }
    },
    clickOption(opt, item) {
      this.$emit(opt.toLowerCase(), item);
    },
    disableOpt(index, item) {
      switch (index) {
          case 1:
              if (item.status !== "Pending") return false
              return item.Tasks.some(task => {
                  logger.info('DEBUG TASK ', task)
                  if (task.context && task.context.pending_otc) {
                      task.context.pending_otc.length > 0 || task.assigned < task.done;
                  }
              })
          default:
              break
      }
    },
    clickRow(item) {
      logger.info(item)
      this.selectedJob = item;

      if (this.expanded[0] && this.expanded[0].id === item.id) {
          this.expanded = []
      } else {
          this.expanded = [item]

          requestAnimationFrame(() => {
              this.$refs.slide.onResize()
          })
      }
    },
    taskHandler(item, task) {
      this.org = this.returnOrgID(item.org);
      this.task = task
      this.transfer = true
    },
    viewTask(item, task) {
      this.mode = Object.assign({}, item)
      this.modal = true
      this.$nextTick(() => {
          this.$refs.addjob.editTask(task)
      })
    },
    handleJob(event) {
      logger.debug('handle event : ', event)
      switch (event.action) {
          case "add":
              this.jobs.push(event.job)
              break

          case "modify":
              this.jobs.some((job, i) => {
                  if (job.id === event.job.id) {
                      this.$set(this.jobs, i, event.job)
                      return true
                  }
                  return false
              })
              break
          case "remove":
              this.jobs = this.jobs.filter(job => job.id !== event.job.id)
              break
          default:
              break
      }
    }
  }
}
</script>

<style lang="scss">
  .jobs-search-bar {
      padding-top: 1em;
      padding-left: 1em;
  }
  .updating {
    animation-name: spin;
    animation-duration: 750ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear; 
  }

  @keyframes spin {
    from {
        transform:rotate(0deg);
    }
    to {
        transform:rotate(360deg);
    }
  }
</style>
